import Page from './Page';
import DivisionDetails from './DivisionDetails';
import reducer from './reducer';

export const reducers = {
  divisionManager: reducer,
};

export default {
  Page,
  DivisionDetails,
  reducers,
};